module.exports = __webpack_public_path__ + "files/e1ee97104756ed42ccd32ad2eccfdc43.svg";